export const Parallax = (event: any, items: any) => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    document.body.style.overflow = 'hidden';
    let objects = document.querySelectorAll(`.${items}`);
    objects.forEach((shift: any) => {
        const position = shift.getAttribute("data-value");
        const x = (window.innerWidth + event.pageX * position) / 90;
        const y = (window.innerHeight + event.pageY * position) / 90;
        shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
    });
}